import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { Area } from 'src/app/_models/area.model';
import { City } from 'src/app/_models/city.model';
import {
  FullPatient,
  PatientSubscription,
} from 'src/app/_models/patient.model';
import { Pharmacy } from 'src/app/_models/PSP/pharmacy.model';
import { AreaService } from 'src/app/_services/area.service';
import { CityService } from 'src/app/_services/city.service';
import { PatientService } from 'src/app/_services/patient.service';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';
import { PharmaciesService } from 'src/app/_services/PSP/pharmacies.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PspSubscriptionStatusEnum } from '../../../enums/psp-subscription-status-enum';
import { InsulinCenter } from 'src/app/_models/PSP/psp-insulin.model';
import { PspInsulinService } from 'src/app/_services/PSP/psp-insulin.service';
import { MedicationRequestBoxService } from 'src/app/_services/PSP/medication-request-box.service';

@Component({
  selector: 'app-request-pick-up',
  templateUrl: './request-pick-up.component.html',
  styleUrls: ['./request-pick-up.component.scss'],
})
export class RequestPickUpComponent implements OnInit {
  cityList: City[];
  areaList: Area[];
  requestData: any = {};
  stepCount = 1;
  pharmacyList: Pharmacy[] = [];
  selectedPharmacy = { id: 0 } as Pharmacy;
  subscriptionId: number;
  patientId: number;
  RequestNotes: string;
  requestFOC;
  requestEmptyBoxes;
  requestSalesPurchase;
  patient: FullPatient;
  selectedSubscription: PatientSubscription;
  discountToggle: boolean = false;
  discountedItemsQuantity: number = 1;
  programPublicPrice: number;
  discountPercentage: string = '';
  totalPriceAfterDiscount: number = 0;
  form: FormGroup;
  pspSubscriptionStatus: typeof PspSubscriptionStatusEnum =
    PspSubscriptionStatusEnum;
  isInsulinProgram = false;
  referralCenters?: InsulinCenter[];
  referralCenterId = null;
  isRocheProgram = false;
  hasPatientDispensedBoxes: boolean = false;
  constructor(
    private cityService: CityService,
    private areaService: AreaService,
    private pharmacyService: PharmaciesService,
    private medicationService: MedicationRequestService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toaster: ToastrService,
    private patientService: PatientService,
    private fb: FormBuilder,
    private pspInsulinService: PspInsulinService,
    private medicationRequestBoxService: MedicationRequestBoxService
  ) {
    this.form = this.fb.group({
      quantity: [null, Validators.pattern(/^[1-9]*$/)]
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.subscriptionId = params.subscriptionId;
      this.patientId = params.patientId;
    });
    if (!this.patientService.patient) {
      this.goBack();
    }
    this.patient = this.patientService.patient;
    this.selectedSubscription = this.patientService.selectedSubscription;
    this.programPublicPrice = this.selectedSubscription?.program?.productPrice;
    this.isInsulinProgram = this.medicationService.isInsulinRequest(
      this.selectedSubscription?.program?.name
    );
    this.isRocheProgram = this.medicationService.isRocheRequest(
      this.selectedSubscription?.program?.companyName
    );

    this.requestEmptyBoxes = this.isRocheProgram ? 0 : null;
    this.cityService.getAllCities().subscribe((res) => {
      this.cityList = res;
    });

    if (this.isInsulinProgram) {
      this.pspInsulinService.getInsulinCenters().subscribe((res) => {
        this.referralCenters = res.data;
      });
    }
    this.hasPatientDispensedBoxesForProgram();
  }

  onCityChange(cityId, flag = true) {
    if (cityId) {
      this.areaService.getAreasByCityId(cityId).subscribe((res) => {
        this.areaList = res?.data?.areas;
        if (flag) {
          this.requestData.areaId = null;
        }
        this.requestData.cityId = cityId;
        this.requestData.cityName = this.cityList.find(
          (city) => city.id === +cityId
        )?.enName;
      });
    }
  }
  onAreaChange(areaId) {
    if (areaId) {
      this.requestData.areaId = areaId;
      this.requestData.areaName = this.areaList.find(
        (area) => area.id === +areaId
      )?.enName;
    }
  }
  searchPharmacy(searchString) {
    this.pharmacyService
      .searchPspPharmacies(
        this.requestData.areaId,
        searchString,
        this.isInsulinProgram
      )
      .subscribe((res) => {
        this.pharmacyList = res?.data?.pharmacies;
      });
  }

  onChange(event) {
    this.selectedPharmacy = event;
  }

  changeStep(step) {
    this.stepCount = step === 4 ? 3 : step;
    switch (step) {
      case 1:
        break;

      case 2:
        this.pharmacyService
          .getPspPharmaciesByAreaId(
            this.requestData.areaId,
            this.isInsulinProgram
          )
          .subscribe((res) => {
            this.pharmacyList = res?.data?.pharmacies;
          });
        break;

      case 3:
        this.programPublicPrice =
          this.selectedSubscription?.program?.productPrice;
        break;

      case 4:
        if (!this.discountToggle) {
          const body = {
            subscriptionId: this.subscriptionId,
            // "patientAddressId": 2,
            pspPharmacyId: this.selectedPharmacy.id,
            notes: this.RequestNotes,
            freeOfChargeCount: this.requestFOC > 0 ? this.requestFOC : null,
            emptyBoxesCount:
              this.requestEmptyBoxes > 0 ? this.requestEmptyBoxes : null,
            purchasesCount:
              this.requestSalesPurchase > 0 ? this.requestSalesPurchase : null,
            referralCenterId: this.referralCenterId,
          };
          this.medicationService.addMedicationRequest(body).subscribe((res) => {
            showNotification(
              'success',
              'pickup request successfully Submitted',
              this.toaster
            );
            this.router.navigateByUrl('/patient-details/' + this.patientId);
          });
        } else {
          const body = {
            subscriptionId: this.subscriptionId,
            pspPharmacyId: this.selectedPharmacy.id,
            notes: this.RequestNotes,
            quantity:
              this.discountedItemsQuantity > 0
                ? this.discountedItemsQuantity
                : null,
            publicPrice:
              this.programPublicPrice > 0 ? this.programPublicPrice : null,
            percentageOfTheDiscount:
              parseFloat(this.discountPercentage) > 0
                ? parseFloat(this.discountPercentage)
                : null,
            totalPriceAfterDiscount:
              this.totalPriceAfterDiscount > 0
                ? this.totalPriceAfterDiscount
                : null,
            referralCenterId: this.referralCenterId,
            emptyBoxesCount: this.requestEmptyBoxes > 0 ? this.requestEmptyBoxes : null,
          };
          this.medicationService.addMedicationRequest(body).subscribe((res) => {
            showNotification(
              'success',
              'pickup request successfully Submitted',
              this.toaster
            );
            this.router.navigateByUrl('/patient-details/' + this.patientId);
          });
        }

      default:
        break;
    }
  }

  goBack() {
    window.history.back();
  }

  changeToggle() {
    this.discountToggle = !this.discountToggle;
    if (this.discountToggle) {
      this.requestFOC = null;
      this.requestSalesPurchase = null;
      this.requestEmptyBoxes = this.isRocheProgram ? this.requestEmptyBoxes : null;
      this.discountedItemsQuantity = 1;
      this.programPublicPrice =
        this.selectedSubscription?.program?.productPrice;
    }
    if (!this.discountToggle) {
      this.requestEmptyBoxes = this.isRocheProgram ? this.requestEmptyBoxes : null;
      this.discountedItemsQuantity = null;
      this.programPublicPrice = null;
      this.discountPercentage = null;
      this.totalPriceAfterDiscount = null;
    }
  }

  onBundleInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');

    input.value = sanitizedValue;
  }

  onDiscountQtyInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    // Remove non-numeric characters
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    
    if (sanitizedValue !== '') {
      let numericValue = parseInt(sanitizedValue);

      if (this.isRocheProgram) {
        // For Roche program: min = 1, max = 6
        if (numericValue < 1) {
          numericValue = 1;
        } else if (numericValue > 6) {
          numericValue = 6;
        }
      } else {
        // For non-Roche programs: min = 1
        if (numericValue < 1) {
          numericValue = 1;
        }
      }

      input.value = numericValue.toString();
      this.discountedItemsQuantity = numericValue;
    } else {
      input.value = '';
      this.discountedItemsQuantity = null;
    }
  }

  onDiscountPercentageChange(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    if (inputValue !== '') {
      let sanitizedValue = inputValue.replace(/[^0-9.]/g, '');

      if (sanitizedValue.startsWith('.')) {
        sanitizedValue = '0' + sanitizedValue;
      }
      sanitizedValue = sanitizedValue.replace(/(\..*)\./g, '$1');

      const parsedValue = parseFloat(sanitizedValue);

      if (parsedValue >= 1 && parsedValue <= 99) {
        input.value = sanitizedValue;
        this.discountPercentage = sanitizedValue.toString();

        this.calculateTotalPriceAfterDiscount();
      } else if (parsedValue < 1) {
        input.value = '1';
      } else if (parsedValue > 99) {
        input.value = '99';
      } else {
        input.value = '';
      }
    }
  }

  calculateTotalPriceAfterDiscount() {
    const quantity = this.discountedItemsQuantity || 0;

    const rowTotal =
      quantity *
      this.programPublicPrice *
      (1 - parseFloat(this.discountPercentage) / 100);
    this.totalPriceAfterDiscount = parseFloat(rowTotal.toFixed(2));
  }

  hasPatientDispensedBoxesForProgram() {
    this.medicationRequestBoxService
      .hasPatientDispensedBoxes(this.selectedSubscription.id)
      .subscribe(res => {
        this.hasPatientDispensedBoxes = res.data;
      });
  }

  emptyBoxesDisabled(): boolean {
    if(this.isRocheProgram){
      return !this.hasPatientDispensedBoxes;
    } else {
      return this.discountToggle;
    }
  }

  isValidRequestEmptyBoxes(): boolean {
    if (this.isRocheProgram) {
      if(this.discountToggle){
        return this.requestEmptyBoxes >= 0 && this.requestEmptyBoxes <= 6;
      }
      else {
        return this.requestEmptyBoxes > 0 && this.requestEmptyBoxes <= 6;
      }
    }

    return !!this.requestEmptyBoxes;
  }

  isValidDiscountedItemsQuantity(): boolean {
    if (this.isRocheProgram) {
      return this.discountedItemsQuantity >= 1 && this.discountedItemsQuantity <= 6;
    }

    return !!this.discountedItemsQuantity;
  }

  isRequestFormDisabled(): boolean {
    const missingRequiredLocation = !this.requestData.cityId || !this.requestData.areaId;

    const discountFieldsIncomplete =
      this.discountToggle &&
      (
        !this.isValidDiscountedItemsQuantity() ||
        !this.discountPercentage ||
        !this.programPublicPrice
      );

    const noRequestOptionsSelected =
      !this.discountToggle &&
      !this.requestFOC &&
      !this.requestSalesPurchase &&
      !this.isValidRequestEmptyBoxes();

    const invalidEmptyBoxes = 
      this.hasEmptyBoxesValue() && 
      !this.isValidRequestEmptyBoxes();

      const invalidFoc = 
      this.hasFocValue() && 
      !this.isValidFocBoxes();

    const insulinProgramMissingReferral = this.isInsulinProgram === true && this.referralCenterId === null;

    const noRocheDataSelected =
      this.isRocheProgram &&
      !this.discountToggle &&
      !this.requestFOC;

    return (
      missingRequiredLocation ||
      discountFieldsIncomplete ||
      noRequestOptionsSelected ||
      invalidEmptyBoxes ||
      invalidFoc ||
      insulinProgramMissingReferral ||
      noRocheDataSelected
    );
  }

  hasEmptyBoxesValue(): boolean {
    return this.isRocheProgram 
        ? this.requestEmptyBoxes > 0 
        : this.requestEmptyBoxes != null;
  }

  hasFocValue(): boolean {
    return this.isRocheProgram 
        ? this.requestFOC > 0 
        : this.requestFOC != null;
  }

  isValidFocBoxes(): boolean {
    if (this.isRocheProgram) {
      return this.requestFOC > 0 && this.requestFOC <= 6;
    }

    return !!this.requestFOC;
  }

  onFocInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    // Remove non-numeric characters
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    
    if (sanitizedValue !== '') {
      let numericValue = parseInt(sanitizedValue);

      if (this.isRocheProgram) {
        // For Roche program: min = 1, max = 6
        if (numericValue < 1) {
          numericValue = 1;
        } else if (numericValue > 6) {
          numericValue = 6;
        }
      }

      input.value = numericValue.toString();
      this.requestFOC = numericValue;
    } else {
      input.value = '';
      this.requestFOC = null;
    }
  }

  onEmptyBoxesInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    // Remove non-numeric characters
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    
    if (sanitizedValue !== '') {
      let numericValue = parseInt(sanitizedValue);

      if (this.isRocheProgram) {
        // For Roche program: min = 0, max = 6
        if (numericValue < 0) {
          numericValue = 0;
        } else if (numericValue > 6) {
          numericValue = 6;
        }
      } else {
        // For non-Roche programs: min = 1
        if (numericValue < 1) {
          numericValue = 1;
        }
      }

      input.value = numericValue.toString();
      this.requestEmptyBoxes = numericValue;
    } else {
      input.value = '';
      this.requestEmptyBoxes = this.isRocheProgram ? 0 : null;
    }
  }
}
